import * as Sentry from '@sentry/react'

if (!__DEV__) {
  Sentry.init({
    integrations: [Sentry.replayIntegration(), Sentry.browserTracingIntegration()],
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: __APP_VERSION__,
    sendDefaultPii: true,
    debug: __DEV__,
    // Session Replay
    replaysSessionSampleRate: __DEV__ ? 1 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Tracing
    tracesSampleRate: __DEV__ ? 1 : 0.1,
  })
}
